export default __webpack_public_path__ + "static/media/logo-research-with-impact.6d39678c.svg";